var XPortal = XPortal || {};
XPortal.Event = XPortal.Event || {};
XPortal.Events = (function () {
    var profile = { enable: false, console: false, detail: false, model: true, entity: false };
    var self = {
        helpers: {//each help data, method is accessible from event
            postProcessEvent: function (action, next) {
                //The most basic middleware, which does literally nothing except forward the action on to the next middleware, is
                //const middleware = store => next => action => next(action)
                return null;//next(action);
            },
            getQuery: function (xfield, xoperator, xvalue, xquery, xcondition = "and", xtype = "") {
                xquery = xquery || {};
                xquery.Filter = xquery.Filter || {};
                xquery.Filter.Filters = xquery.Filter.Filters || [];
                xquery.Filter.Filters.push({
                    Field: xfield,
                    Operator: xoperator ? xoperator : "=",
                    Value: xvalue,
                    Logic: xcondition,
                    Type: xtype
                });
                return xquery;
            },
            isOneOfFields: function (action) {
                var cfname = action && action.field && action.field.field ? action.field.field.toLowerCase() : false;
                if (!cfname || cfname.length < 1) return false;
                var fname = _.find(arguments, function (f) {
                    if (f === action) return false;
                    var r = f && f.length > 0 ? f.toLowerCase() === cfname : false;
                    return r;
                });
                return fname ? true : false;
            },
            isForEntity: function () {
                var curEntityName = this.SenderModel && this.SenderModel.model ? this.SenderModel.model.Alias : false;
                if (!curEntityName || curEntityName.length < 1) return false;
                curEntityName = curEntityName.toLowerCase();
                var ename = _.find(arguments, function (f) {
                    var r = f && f.length > 0 ? f.toLowerCase() === curEntityName : false;
                    return r;
                });
                return ename ? true : false;
            },
            getActualEntityFieldData: function (action, entity, fname) {
                var rr = action && action.field && action.field.field == fname ? action.field.data : XPortal.Template.GetObjPropValueByName(entity, fname);
                return rr;
            },
            ensureCurrentEntityNotChanged: function (modelName, entity, fields, eventFinalizationCallback, onchanged) {
                var currentModel = XPortal.Store.GetModelByName(modelName);
                var currentEntity = currentModel.entity;

                // When entity is the same - validating fields and in case if any is changed - skipping current event
                if (currentEntity && fields && currentEntity.UniqueId === entity.UniqueId && fields.length > 0) {
                    var entityChanged = false;
                    fields.forEach(function (fieldName) {
                        var value = entity[fieldName];
                        var currentValue = currentEntity[fieldName];
                        if (value !== currentValue) {
                            entityChanged = true;
                        }
                    });

                    if (entityChanged) {
                        return (onchanged ? onchanged() : true);
                    }
                }

                currentModel.entity = entity;
                eventFinalizationCallback();
                currentModel.entity = currentEntity;
            },

            DispatchForOtherEntity: function (modelName, entity, dataFields, dispatchAnyWay, beforeChageModelEntity, saveChanges) {
                return XPortal.Store.DispatchForOtherEntity(modelName, entity, dataFields, dispatchAnyWay, beforeChageModelEntity, saveChanges);
            },
            DispatchWithoutEvents: function (modelName, entity, dataFields, beforeChageModelEntity, omitAutosave, reloadGridData) {
                var changes = 0;
                if (dataFields && dataFields.length > 0) {
                    var centity = entity;
                    dataFields.forEach(x => {
                        if (x != null && x.name) {
                            if (centity.set) centity.set(x.name, x.value);
                            centity[x.name] = x.value;
                            //check entity - & dispatch changes without processing any other event
                            var model = XPortal.Store.GetModelByName(modelName);
                            var srcState = null;
                            if (!model.entity || model.entity.UniqueId != entity.UniqueId) {
                                srcState = model.entity;
                                if (beforeChageModelEntity) beforeChageModelEntity(model.entity, x.name, x.value);
                                XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.BIND_ENTITY, modelName: modelName, entity: entity });
                            }
                            XPortal.Store.DispatchWithoutEvents(modelName, x.name, x.value, omitAutosave ? true : false, reloadGridData ? true : false);
                            if (srcState != null)
                                XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.BIND_ENTITY, modelName: modelName, entity: srcState });
                            changes++;
                        }
                    });
                }
                return changes > 0;
            },
            DispatchInBground: function (dataFields, onItem, canprocess, ondone) {
                dataFields = dataFields || [];
                var i = 1;
                self.Profile("-----DispatchInBground", null, null, { dataFields });
                return new Promise(function (resolve) {
                    //items, onGetNext, onItem, ix, ondone, tmiterval, canprocess
                    XPortal.Store.processListAsync(dataFields[0], async function () {
                        return (i < dataFields.length) ? { data: dataFields[i++], index: i } : null;
                    }, onItem, 0, function () { resolve(); ondone(); }, 200, canprocess);
                });
            },
            dispatchNoAutoSaveIfChanged: function (modelName, fieldName, fieldValueToSet) {
                var cEntity = XPortal.Store.GetModelByName(modelName).entity;
                if (cEntity && cEntity[fieldName] === fieldValueToSet) return false;
                XPortal.Store.DispatchNoAutoSave(modelName, fieldName, fieldValueToSet);
                return true;
            },
            dispatchByNameIfChanged: function (modelName, fieldName, fieldValueToSet, dispachAnyWay) {
                var cEntity = XPortal.Store.GetModelByName(modelName).entity;
                if (!dispachAnyWay && cEntity && cEntity[fieldName] === fieldValueToSet) return false;
                XPortal.Store.DispatchByName(modelName, fieldName, fieldValueToSet);
                return true;
            },
            getRelatedDataNodeId: function (entityType, nodeId, relatedEntityType) {
                if (!relatedEntityType) {
                    return 0;
                }

                var key = entityType + "_" + nodeId;
                var eventData = XPortal.Event[key];
                if (!eventData) {
                    return 0;
                }

                var eventsMetadata = eventData.eventsMetadata();
                if (!eventsMetadata || eventsMetadata.length === 0) {
                    return 0;
                }

                var metaData = eventsMetadata.find(emd => emd.relatedEntity.toLowerCase() === relatedEntityType.toLowerCase());
                if (!metaData) {
                    return 0;
                }

                return metaData.relatedNodeId;
            },
            warn: warn
        },
        EnsureMidlewareActionContext: function (next, action, midlWarContext, onOk) {
            if ((action.type !== XPortal.Redusers.ACTIONS.EDIT_FIELD &&
                action.type !== XPortal.Redusers.ACTIONS.DELETED_ENTITY &&
                action.type !== XPortal.Redusers.ACTIONS.LOADED_ENTITY &&
                action.type !== XPortal.Redusers.ACTIONS.EDITOR_LOADED && 
                action.type !== XPortal.Redusers.ACTIONS.GRID_INITIALIZED && 
                action.type !== XPortal.Redusers.ACTIONS.GRID_DATALOADED                
                ) || !action.model)
                return next(action);

            if (action.type === XPortal.Redusers.ACTIONS.DELETED_ENTITY ||
                action.type === XPortal.Redusers.ACTIONS.GRID_INITIALIZED ||
                action.type === XPortal.Redusers.ACTIONS.GRID_DATALOADED ||
                action.type === XPortal.Redusers.ACTIONS.LOADED_ENTITY)
                action.field = action.field || { field: "*" };

            var modelId = midlWarContext.HandlerModelId;
            var model = XPortal.Store.GetModelByName(action.model);
            var HandlerModelName = XPortal.Store.GetModelByNodeId(modelId);
            if (!model || !HandlerModelName) return next(action);
            //compare script model id and event model id for event segregation
            if (HandlerModelName.startsWith("GM.") && HandlerModelName !== action.model) //grid can only hear its own events
                return next(action);

            var entity = action.entity ? action.entity : model.entity;
            //since sender model is not updated when we handle it we create user grid model representation 
            //to allow correct grid calculations
            if (model.GridModel) // a kind of helper for user scripts
                model.GetGridItems = function () {
                    let items = this.GridModel.dataSource.view();
                    if (action.type !== XPortal.Redusers.ACTIONS.DELETED_ENTITY) {
                        if (this.entity) {
                            items = items.filter(e => e.uid !== this.entity.uid);
                            const modified = Object.assign({}, this.entity);
                            modified[action.field.field] = action.field.data;
                            items.push(modified);
                        }
                    }
                    return items;
                };


            var HandlerModel = XPortal.Store.GetModelByName(HandlerModelName);
            var dispatch = midlWarContext.dispatch;
            midlWarContext = $.extend({
                HandlerModel, HandlerModelName, SenderModel: model,
                fillValue: function (fieldName, value, modelName, en) {
                    var itemToDispatch = {
                        type: XPortal.Redusers.ACTIONS.EDIT_FIELD,
                        model: modelName ? modelName : this.HandlerModelName,
                        field: {
                            field: fieldName,
                            data: value
                        },
                        entity: en ? en : entity
                    };
                    dispatch(itemToDispatch);
                },
                dispatch: function (itemToDispatch) {
                    itemToDispatch.entity = itemToDispatch.entity ? itemToDispatch.entity : this.HandlerModel.entity;
                    dispatch(itemToDispatch);
                },
                profile: self.Profile,
                warn: warn
            }, self.helpers, midlWarContext);
            return onOk(midlWarContext, entity);
        },
        Profile: function (message, priority, action, entity, ...args) {
            if (args.length > 0 || action || entity)
                warn(message, priority, action, entity, ...args);
            else
                warn(message, priority);
            if (!profile.enable) return message;
            const model = action ? action.model : null;
            const tstemp = moment();
            const thstmp = tstemp.format("MM.DD-hh:mm:ss.SSS");
            if (profile.detail)
                storeProfiler("profiler", tstemp, function (profiler) {
                    profiler.History = profiler.History || [];
                    profiler.History.push({ t: thstmp, m: message, more: { m: model, id: entityId, a: action, d: args } });
                });

            var entityId = entity ? entity.linesubtype + "_" + entity.UniqueId : null;
            var entityObj = { lgr: entity ? entity.linegroupid : null, lst: entity ? entity.linesubtype : null, lt: entity ? entity.type : null, a: entity ? entity.alias : null, m: model };
            if (model && profile.model) {
                storeProfiler("profilerModels", tstemp, function (profiler) {
                    var m = profiler[model] = profiler[model] || { history: [], entities: {} };
                    if (entityId) {
                        var e = m.entities[entityId] = m.entities[entityId] || $.extend({ history: [] }, entityObj);
                        e.history.push({ t: thstmp, m: message, more: { m: model, id: entityId, a: action, d: args } });
                    } else m.history.push({ t: thstmp, m: message, more: { m: model, id: entityId, a: action, d: args } });

                });
            }
            if (entityId && profile.entity) {
                storeProfiler("profilerEntities", tstemp, function (profiler) {
                    var m = profiler[entityId] = profiler[entityId] || $.extend({ history: [] }, entityObj);
                    m.history.push({ e: entity.alias, t: thstmp, m: message, more: { m: model, id: entityId, a: action, d: args } });
                });
            }
        }
    };
    function assignModifiedProperties(src, dst) {
        var mobj = {};
        var amount = 0;
        for (var prName in src) {
            var fieldExists = prName !== prName.toLowerCase() ? false : src.Fields.find(function (f) { return f.Name.toLowerCase() == prName; });
            if (fieldExists) {
                if (String(src[prName]) != String(dst[prName])) {
                    mobj[prName] = dst[prName];
                    amount++;
                }
            }
        }
        if (amount < 1) return src;
        return Object.assign(src, mobj);
    }
    function warn(msg, iscritical, ...args) {
        if (!console) return;
        const stack = [];// (new Error().stack || "").split("\n").slice(1).filter((x) => x.indexOf("portal.store.js") == -1 && x.indexOf("Object.event") == -1 && x.indexOf("Object.EnsureMid") == -1 && x.indexOf("warn (http") == -1);
        const iargs = [...args, ...stack];
        if (iscritical > 0) return iargs.length > 0 ? console.error(msg, iargs) : console.error(msg);
        if (iscritical == 0) return iargs.length > 0 ? console.warn(msg, iargs) : console.warn(msg);
        return iargs.length > 0 ? console.log(msg, iargs) : console.log(msg);
    };
    function storeProfiler(key, date, newMessage) {
        var profiler = profilers[key];
        if (!profiler) {
            profiler = JSON.parse(window.localStorage.getItem(key) || "{}");
            profilers[key] = profiler;
        }
        if (profiler.date && profiler.date != date.format("YY.MM.DD")) {
            clearTimeout(profiler.timeout);
            profiler = {};
            profilers[key] = profiler;
        }
        profiler.date = date.format("YY.MM.DD");
        clearTimeout(profiler.timeout);
        newMessage(profiler);
        profiler.timeout = setTimeout(function () {
            window.localStorage.setItem(key, JSON.stringify(profiler));
        }, 2500);
    }
    var profilers = [];
    storeProfiler("profiler", moment(), function (profiler) { profiler.History = []; });
    self.Profile("refreshed page", null, null, window.location.href);
    return self;
})();
